import { render } from "./HeroLanding.vue?vue&type=template&id=c498aa56&ts=true"
import script from "./HeroLanding.vue?vue&type=script&lang=ts"
export * from "./HeroLanding.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/l333n/Development/lennarthakker/lennarthakker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__